import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import type { OptionItem } from '../config/options';

interface AgeSelectProps {
  value: string;
  onChange: (value: string, condition: string) => void;
  options: OptionItem[];
  colorMap: Record<string, string>;
  conditionMap: Record<string, string>;
  label?: string;
}

const AgeSelect: React.FC<AgeSelectProps> = ({ value, onChange, options, colorMap, conditionMap, label = 'Age' }) => {
  const color = value && value !== 'n_a' ? colorMap[value] : undefined;

  return (
    <FormControl fullWidth variant="filled">
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={(e) => {
          const val = e.target.value as string;
          const condition = val && val !== 'n_a' ? (conditionMap[val] ?? '') : '';
          onChange(val, condition);
          (e.target as HTMLInputElement).blur();
        }}
        sx={{
          ...(color && {
            bgcolor: color,
            color: '#fff',
            '&.Mui-focused': { bgcolor: color },
            '& .MuiSelect-icon': { color: '#fff' },
            '& .MuiFilledInput-input': { color: '#fff' },
          }),
        }}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default AgeSelect;
